import { render, staticRenderFns } from "./WorkExampleEditorSlides.vue?vue&type=template&id=c53c226a&scoped=true&"
import script from "./WorkExampleEditorSlides.vue?vue&type=script&lang=js&"
export * from "./WorkExampleEditorSlides.vue?vue&type=script&lang=js&"
import style0 from "./WorkExampleEditorSlides.vue?vue&type=style&index=0&id=c53c226a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53c226a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
